import CompanyInformation from '../company-information';

const ActivateAccount = () => {
  return <CompanyInformation />;
};

export default ActivateAccount;
